// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"b6dab3fd","653":"5a988a3a"}[chunkId] + ".chunk.js";
};